import { StatusCellComponent } from '@shared/components/table/cells/status-cell/status-cell.component';
import { Columns } from '@shared/interfaces/table/column-config';

export const meterFrameStatusPartial: Columns<any> = {
  title: 'meterFrame.status',
  key: 'status',
  cellRenderer: StatusCellComponent,
  cellRendererParams: {
    notspecified: { color: 'bg-yellow-500', label: 'status.unknown' },
    active: { color: 'bg-green-500', label: 'status.active' },
    inactive: { color: 'bg-red-500', label: 'status.inactive' },
  }
}
